import { useExperimentTreatmentWithoutReporting } from '../experiments';

type UseIsSubNetworksEnabled = () => boolean;
export const useIsSubNetworksEnabled: UseIsSubNetworksEnabled = () => {
  const isSubNetworksEnabled = useExperimentTreatmentWithoutReporting('SubNetworksAdminPage') === true;

  return isSubNetworksEnabled;
};
